import {API, Auth} from 'aws-amplify'
import React, {useEffect, useState} from 'react'
import AuthForm from './AuthForm'
import {parseApiFormErrors} from '../lib/apiErrors'
import {REGISTRATION_TYPE_SOLSELL} from '../constants/users'
import '../styles/AuthForm.less'

const Signup = ({}) => {
  const [formErrors, setFormErrors] = useState()
  const [formValues, setFormValues] = useState({
    email: '',
    password: '',
    password_1: '',
    phone_number_0: '',
    phone_number_1: '',
    phone_number_2: '',
    family_name: '',
    given_name: '',
  })
  const [isDisabled, setIsDisabled] = useState(true)

  const handleChange = e => {
    const {target: {name, value}} = e

    let v = value
    if(/phone_number_\d/.test(name)) {
      v = toHalfWidthNumber(v)
    }
    const newFormValues = {...formValues, [name]: v}
    setFormValues(newFormValues)

    if(
      Object.keys(newFormValues).some(item => newFormValues[item].length == 0) ||
      newFormValues.password != newFormValues.password_1
    ) {
      setIsDisabled(true)
    } else {
      setIsDisabled(false)
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    setFormErrors()
    setIsDisabled(true)

    try {
      const headers = {'Content-Type': 'application/json'}

      let userParams = {
        registration_type: REGISTRATION_TYPE_SOLSELL,
        registration_platform: navigator.userAgent.match(/iPhone|Android.+Mobile/) ? 'sp' : 'pc',
      }

      const userIdCookie = document.cookie.split('; ').find(item => item.indexOf('user_id') === 0)
      if(userIdCookie) {
        userParams['user_id'] = userIdCookie.split('=')[1]
      }

      const body = {
        ...formValues, 
        ...{
          phone_number: formValues.phone_number_0 + formValues.phone_number_1 + formValues.phone_number_2,
          q: new URLSearchParams(userParams).toString(),
        }
      }
      const r = await API.post('solsell', 'v1/users/signup', {
        body,
        headers,
        response: true,
      })

      location.href = '/verify'
      return
    }
    catch (err) {
      setFormErrors(parseApiFormErrors(err))
    }

    setIsDisabled(false)
  }

  return (
    <form onSubmit={handleSubmit}>
      <p className="n text-center text-m mb-m">中古No.1、日本最大級の太陽光投資プラットフォーム「SOLSEL」</p>
      <h1 className="b text-center text-lll mb-m">ソルセル<br className="sp"/>新規会員登録<br/>（完全無料）</h1>
      <div className="columns is-centered mb-m">
        <div className="column is-8">
          <img src="/wordpress2/wp-content/themes/solsel/img/common/register-step.png" alt=""/>
        </div>
      </div>
      <div className="bg-gray-l pd-l mb-l">
        <h2 className="n color-blue text-m mb-s">7つの会員特典</h2>
        <ul className="tokutenlist">
          <li><span className="text-m"><i className="fas fa-key color-blue"/></span>
            <p>会員限定！高利回り12％〜「非公開物件」など、常時50件以上ある"ココだけの限定物件"が見れる！マイページで比較検討できる。</p>
          </li>
          <li><span className="text-m"><i className=" fas fa-book color-blue"/></span>
            <p>太陽光投資のことが丸わかり！E-Book『太陽光発電 投資の完全成功マニュアル』が読める！</p>
          </li>
          <li><span className="text-m"><i className=" fas fa-hand-holding-usd color-blue"/></span>
            <p>70万円相当の「ソルセル士業の丸投げ代行サービス」を実質０円でプレゼント！普通に買うより３倍得する消費税還付や税務サービスが使える。</p>
          </li>
          <li><span className="text-m"><i className=" far fa-hand-point-up color-blue"/></span>
            <p>ワンクリック問合せ！物件の資料請求やお問合せでのフォームに入力する手間がなくなる！</p>
          </li>
          <li><span className="text-m"><i className="fas fa-user-tie color-blue"/></span>
            <p>専属スタッフ！一般窓口ではなくSOLSELコンシェルジェがあなたの担当につきます！初心者の方も経験者の方もなんでもご相談ください！</p>
          </li>
          <li><span className="text-m"><i className="fas fa-envelope-open-text color-blue"/></span>
            <p>新着情報！メールやLINEで新しく入った物件情報やセミナー、お役立ちコンテンツを最速でお届け！</p>
          </li>
          <li><span className="text-m"><i className="fas fa-solar-panel color-blue"/></span>
            <p>発電所管理ツール「まとめてソーラー」が利用できる！お持ちの太陽光物件の発電データをスマホからチェック！（準備中）</p>
          </li>
        </ul>
      </div>
      <AuthForm
        formErrors={formErrors}
        formValues={formValues}
        isSignup
        onChange={handleChange}
      />
      <input
        className={`btn btn-center br-5 bg-blue color-w transform transform-scale m-0 ${isDisabled ? 'disabled' : ''}`}
        disabled={isDisabled}
        name="submit"
        type="submit"
        value="確認画面へ"
      />
    </form>
  )
}

const toHalfWidthNumber = s => {
  let n = ''
  for (let i = 0; i < s.length; i++) {
    if(/[０-９]/g.test(s[i])) {
      n += String.fromCharCode(s[i].charCodeAt(0) - 0xFEE0)
    }
    // else if(s[i] == '-' || s[i] == 'ー') {
    //   n += '-'
    // }
    else if(isNaN(Number(s[i]))) {
      n += ''
    }
    else {
      n += s[i]
    }
  }
  return n
}

export default Signup

// import FormErrorList from './FormErrorList'
// import UserForm from './UserForm'

// const FORM_TYPE_CONFIRM = 'confirm'
// const FORM_TYPE_INPUT = 'input'

// const INITIAL_FORM_VALUES = {
//   email: '',
//   family_name: 'test',
//   given_name: 'test',
//   family_name_kana: '',
//   given_name_kana: '',
//   phone_number: '',
//   password: '',
//   password_1: '',
//   group: 'individual',
// }

// export default ({redirectTo = '/'}) => {
//   const [formErrors, setFormErrors] = useState({})
//   const [formValues, setFormValues] = useState(INITIAL_FORM_VALUES)
//   const [formType, setFormType] = useState(FORM_TYPE_INPUT)
//   const [isButtonDisabled, setIsButtonDisabled] = useState(false)

//   const handleChange = e => {
//     const {target: {name, value}} = e
//     if(name == 'phone_number' && !/[0-9]+/.test(value)) {
//       return
//     }
//     setFormValues({...formValues, [name]: value})
//   }

//   const handleClickModify = e => {
//     e.preventDefault()
//     setFormType(FORM_TYPE_INPUT)
//     window.scrollTo(0, 0)
//   }

//   const handleSubmit = async e => {
//     e.preventDefault()

//     setIsButtonDisabled(true)

//     try {
//       const headers = {'Content-Type': 'application/json'}

//       const r = await API.post('solsell', 'v0/users', {
//         body: formValues,
//         headers,
//         response: true,
//       })

//       location.href = redirectTo
//     }
//     catch (error) {
//       console.log('error signing up:');
//       if(error.hasOwnProperty('response')) {
//         const {data: {error: _error}} = error.response
        
//         if(_error) {
//           const err = typeof _error == 'string' ? {form: [_error]} : _error
//           setFormErrors(err)
//         }
//       }

//       setFormType(FORM_TYPE_INPUT)
//       window.scrollTo(0, 0)
//     }

//     setIsButtonDisabled(false)
//   }

//   const handleSubmitConfirm = async e => {
//     e.preventDefault()

//     if(formValues.password != formValues.password_1) {
//       setFormErrors({password_1: ['パスワードが一致しません。']})
//       return
//     }

//     setFormType(FORM_TYPE_CONFIRM)
//     window.scrollTo(0, 0)
//   }

//   return (
//     <div>
//       {formType == FORM_TYPE_INPUT ? (
//         <form onSubmit={handleSubmitConfirm}>
//           <p className="n text-center text-m mb-m">中古No.1、日本最大級の太陽光投資プラットフォーム「SOLSEL」</p>
//           <h1 className="b text-center text-lll mb-m">ソルセル<br className="sp"/>新規会員登録<br/>（完全無料）</h1>
//           <div className="columns is-centered mb-m">
//             <div className="column is-8">
//               <img src="/wordpress2/wp-content/themes/solsel/img/common/register-step.png" alt=""/>
//             </div>
//           </div>
//           <div className="bg-gray-l pd-l mb-l">
//             <h2 className="n color-blue text-m mb-s">7つの会員特典</h2>
//             <ul className="tokutenlist">
//               <li><span className="text-m"><i className="fas fa-key color-blue"/></span>
//                 <p>会員限定！高利回り12％〜「非公開物件」など、常時50件以上ある"ココだけの限定物件"が見れる！マイページで比較検討できる。</p>
//               </li>
//               <li><span className="text-m"><i className=" fas fa-book color-blue"/></span>
//                 <p>太陽光投資のことが丸わかり！E-Book『太陽光発電 投資の完全成功マニュアル』が読める！</p>
//               </li>
//               <li><span className="text-m"><i className=" fas fa-hand-holding-usd color-blue"/></span>
//                 <p>70万円相当の「ソルセル士業の丸投げ代行サービス」を実質０円でプレゼント！普通に買うより３倍得する消費税還付や税務サービスが使える。</p>
//               </li>
//               <li><span className="text-m"><i className=" far fa-hand-point-up color-blue"/></span>
//                 <p>ワンクリック問合せ！物件の資料請求やお問合せでのフォームに入力する手間がなくなる！</p>
//               </li>
//               <li><span className="text-m"><i className="fas fa-user-tie color-blue"/></span>
//                 <p>専属スタッフ！一般窓口ではなくSOLSELコンシェルジェがあなたの担当につきます！初心者の方も経験者の方もなんでもご相談ください！</p>
//               </li>
//               <li><span className="text-m"><i className="fas fa-envelope-open-text color-blue"/></span>
//                 <p>新着情報！メールやLINEで新しく入った物件情報やセミナー、お役立ちコンテンツを最速でお届け！</p>
//               </li>
//               <li><span className="text-m"><i className="fas fa-solar-panel color-blue"/></span>
//                 <p>発電所管理ツール「まとめてソーラー」が利用できる！お持ちの太陽光物件の発電データをスマホからチェック！（準備中）</p>
//               </li>
//             </ul>
//           </div>

//           <UserForm
//             formErrors={formErrors}
//             formValues={formValues}
//             isRegistration={true}
//             onChange={handleChange}
//           />

//           <input
//             className="btn btn-center br-5 bg-blue color-w transform transform-scale m-0"
//             disabled={isButtonDisabled}
//             name="submit"
//             type="submit"
//             value="確認画面へ"
//           />
//         </form>
//       ) : (
//         <form onSubmit={handleSubmit}>
//           <h1 className="b text-center text-lll mb-m">情報の確認</h1>
//           <div className="columns is-centered mb-m">
//             <div className="column is-8">
//               <img src="/wordpress2/wp-content/themes/solsel/img/common/register-step-2.png" alt=""/>
//             </div>
//           </div>

//           <span className="block n color-gray-d">お名前</span>
//           <div className="columns mb-m is-multiline is-mobile">
//             <div className="column is-6">{formValues.family_name}</div>
//             <div className="column is-6">{formValues.given_name}</div>
//           </div>

//           <span className="block n color-gray-d">お名前（ふりがな）</span>
//           <div className="columns mb-m is-multiline is-mobile">
//             <div className="column is-6">{formValues.family_name_kana}</div>
//             <div className="column is-6">{formValues.given_name_kana}</div>
//           </div>

//           <span className="block n color-gray-d">メールアドレス</span>
//           <div className="columns mb-m is-multiline is-mobile">
//             <div className="column">{formValues.email}</div>
//           </div>

//           <span className="block n color-gray-d">電話番号</span>
//           <div className="columns mb-m is-multiline is-mobile">
//             <div className="column">{formValues.phone_number}</div>
//           </div>

//           <span className="block n color-gray-d">パスワード</span>
//           <div className="columns mb-m is-multiline">
//             <div className="column">セキュリティのため、表示していません。</div>
//           </div>

//           <span className="block n color-gray-d">個人・法人</span>
//           <div className="columns mb-m is-multiline">
//             <div className="column">{formValues.group == 'individual' ? '個人' : '法人'}</div>
//           </div>

//           <input
//             className="btn btn-center br-5 bg-blue color-w transform transform-scale m-0"
//             disabled={isButtonDisabled}
//             name="submit"
//             type="submit"
//             value="登録する"
//           />
//           <div style={{textAlign: 'center'}} className="mt-l">
//             <a
//               className="n text-ss column icon icon-left icon-chevron-right icon-blue-l color-b"
//               href="#"
//               onClick={handleClickModify}
//             >
//               修正する
//             </a>
//           </div>
//         </form>
//       )}
//     </div>
//   )
// }
